import { isChrome, isFirefox, isIOS, isMobileSafari, isSafari, osName } from 'react-device-detect';
import { isMobileOS } from 'utils/browser-util';
import getInitialState from './initialState';

export default {
  setApplication: (state, settings) => Object.assign(state, settings),

  setKwtMode: (state, kwtMode) => Object.assign(state, { kwtMode }),

  determineDeviceCapabilities: state => {
    return Object.assign(state, {
      device: {
        ...state.device,
        isChromeOS: osName === 'Chromium OS', // used for chrome books only
        isIOSApp: isIOS && isMobileSafari && !isChrome && !isFirefox && !isSafari,
        isInIframe: window !== window.parent,
        isMobile: isMobileOS()
      }
    });
  },

  setToolbarMode: (state, mode) => Object.assign(state, { toolbarMode: mode }),

  chooseMobileKeyboard: (state, choice) =>
    Object.assign(state, {
      device: { ...state.device, usingExternalKeyboard: choice }
    }),

  setModal: (state, modal) => Object.assign(state, { modal }),

  setVideoData: (state, { video }) => Object.assign(state, { video }),

  resetApplication: state => Object.assign(state, { ...getInitialState() }),

  setLiteVersion: (state, liteVersion) => Object.assign(state, { isLiteVersion: liteVersion }),

  setAccessibilityMode: (state, isAccessibilityModeOn) =>
    Object.assign(state, { accessibilityMode: isAccessibilityModeOn })
};
